<template>
  <div class="container">
    <div class="signature_container">
      <div class="row">
        <div class="col">
          <button class="btn btn-info" @click="save()">{{ $trans.main.button_save }}</button>
          <button class="btn btn-danger" @click="setCtx()">{{ $trans.main.button_clear }}</button>
          <button class="btn btn-primary" @click="back()">{{ $trans.main.button_cancel }}</button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <canvas :id="canvas_id"
                  class="border"
                  ref="canvas"
                  v-touch:tap="start"
                  v-touch:start="start"
                  v-touch:end="finish"
                  v-touch:moving="draw"
                  v-on:tap.prevent
                  v-on:start.prevent
                  v-on:touchstart.prevent
                  v-on:touchmove.prevent
                  v-on:touchend.prevent
                  v-on:touchcancel.prevent
                  v-on:moving.prevent
          ></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import images from '@/functions/images'
export default {
  name: 'Canvas',
  data: () => ({
    ctx: null,
    painting: false,
    offsetCanvas: {top: 0, left: 0},
    canvas_width: 400,
    canvas_height: 180,
    protocol: {},
    canvas_id: 'id',
    images: images
  }),
  async mounted () {
    this.$refs.canvas.width = this.canvas_width
    this.$refs.canvas.height = this.canvas_height
    this.protocol = await this.$store.getters.getCurrentProtocol
    this.offsetCanvas = this.getOffsetRect()
    this.canvas_id = 'canvas' + this.protocol.id + this.$route.params.subject
    this.init()
  },
  methods: {
    ...mapActions(['getProtocol', 'saveProtocol']),
    init () {
      this.setCtx()
      if (this.protocol[this.$route.params.subject] !== '') {
        let img = new Image()
        var ctx = this.ctx
        img.onload = function () {
          ctx.drawImage(img, 0, 0)
        }
        img.src = this.protocol[this.$route.params.subject]
      }
    },
    setCtx () {
      this.$refs.canvas.getContext('2d').clearRect(0, 0, this.canvas_width, this.canvas_height)
      this.ctx = this.$refs.canvas.getContext('2d')
      this.ctx.lineWidth = 5
      this.ctx.lineCap = 'round'
      this.ctx.strokeStyle = 'blue'
    },
    start (e) {
      this.painting = true
      this.ctx.beginPath()
    },
    finish (e) {
      this.painting = false
    },
    draw (e) {
      if (this.painting) {
        e = this.getTouchPos(e)
        this.stroke(e)
        this.ctx.beginPath()
        this.ctx.moveTo(e.offsetX, e.offsetY)
      }
    },
    stroke (e) {
      this.ctx.lineTo(e.offsetX, e.offsetY)
      this.ctx.stroke()
    },
    getTouchPos (e) {
      if (e.touches) {
        this.offsetCanvas = this.getOffsetRect()
        let touch = e.touches[0]
        let touchX = touch.pageX - this.offsetCanvas.left
        let touchY = touch.pageY - this.offsetCanvas.top
        return {offsetX: touchX, offsetY: touchY}
      } else {
        return {offsetX: e.offsetX, offsetY: e.offsetY}
      }
    },
    async save () {
      this.protocol[this.$route.params.subject] = await this.saveSignature(this.$refs.canvas)
      this.protocol[this.$route.params.subject] = await this.images.imageToBase64(this.protocol[this.$route.params.subject])
      this.protocol.update_signature = true
      this.$store.commit('SET_PROTOCOL', {protocol: this.protocol})
      return this.$router.back()
    },
    async back () {
      this.protocol.update_signature = true
      this.$store.commit('SET_PROTOCOL', {protocol: this.protocol})
      return this.$router.back()
    },
    saveSignature (canvas) {
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          resolve(blob)
        }, 'image/png')
      })
    },
    getOffsetRect () {
      let elem = document.getElementById(this.canvas_id)
      let box = elem.getBoundingClientRect()

      let body = document.body
      let docElem = document.documentElement

      let scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop
      let scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft

      let clientTop = docElem.clientTop || body.clientTop || 0
      let clientLeft = docElem.clientLeft || body.clientLeft || 0

      let top = box.top + scrollTop - clientTop
      let left = box.left + scrollLeft - clientLeft

      return {top: Math.round(top), left: Math.round(left)}
    }

  }
}
</script>

<style>
.signature_container {
  display: block;
  position: fixed;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Signature.vue